import axios from 'axios'
import { handleReactNativeFileDownload } from './webview'
import { MimeType } from '../Types'

/**
 * Download a file from the files endpoint with a specific id for webview and web
 */
export const downloadFile = (
  fileId: string | number,
  fileName: string,
  ext: string,
  apiEndpoint: string,
  token: string | undefined,
  mimeType: MimeType,
  isWebview: boolean
): void => {
  const url = apiEndpoint + `/files/items/${fileId}/file`
  const headers = {
    authorization: token ? 'Bearer ' + token : undefined,
  }

  if (isWebview) {
    axios({
      url,
      responseType: 'arraybuffer', // important
      headers,
    }).then(response => {
      handleReactNativeFileDownload(response.data, fileName, ext, mimeType)
    })
  } else {
    axios({
      url: apiEndpoint + `/files/items/${fileId}/file`,
      responseType: 'blob', // important
      headers,
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.${ext}`) //or any other extension
      document.body.appendChild(link)
      link.click()
    })
  }
}

export const getTruncatedString = ({ text, length = 45 }: { text?: string; length?: number }): string | undefined => {
  if (text && text?.length > length) {
    return text?.substring(0, length) + '...'
  }
  return text
}

export const stringLength = 45

export type CsvHeader = { label: string; key: string }
export type CsvHeaders = CsvHeader[]
export type CsvRow = Record<string, string | number | boolean>
export type CsvData = CsvRow[]

/**
 * Convert CSV data to ArrayBuffer
 */
export const csvToArrayBuffer = (csvData: CsvData, csvHeaders: CsvHeaders): ArrayBuffer => {
  /** Extract the headers (first row) */
  const headerRow = csvHeaders.map(header => header.label).join(',')

  /** Extract the corresponding values for each row */
  const dataRows = csvData.map(row => csvHeaders.map(header => row[header.key] ?? '').join(','))

  /** Combine headers and rows into a CSV string */
  const csvString = [headerRow, ...dataRows].join('\n')

  /** Convert CSV string to ArrayBuffer */
  const encoder = new TextEncoder()
  return encoder.encode(csvString).buffer as ArrayBuffer
}

/**
 * Convert Base64 string to ArrayBuffer
 */
export const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
  /** Decode Base64 to binary string */
  const binaryString = atob(base64)
  const length = binaryString.length
  const bytes = new Uint8Array(length)
  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}
